import React from 'react';
export const Label = (props: any) => {
  return (
    <div className="form-input-label">
      {props.children}
    </div>
  )
}

